module.exports = __webpack_public_path__ + "static/media/main idea.55e1219b.mp3";